/**
 * Title-cases prose. Words that are already all caps are left alone: they are acronyms or record
 * numbers (WO-486168, PR-10061, NTE), and lower-casing their tail turned them into Wo-486168 in
 * every breadcrumb and chip that passed through here.
 *
 * The word boundary deliberately does NOT include the hyphen. Binding a hyphenated string into one
 * token lower-cases its tail, and this runs on the breadcrumb of every service provider, client,
 * entity and location page plus the Brand Name and Location Type columns: "Wal-Mart" became
 * "Wal-mart" and the stored option "stand-alone" became "Stand-alone". The all-caps guard above is
 * what keeps WO-486168 intact - it never needed the hyphen to do that.
 */
export const capitalizeEveryWord = (str: string) =>
  str.replace(/\b\w+/g, (word) =>
    word === word.toUpperCase() ? word : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
  );
